import React from 'react'

export type WorkExperienceDragGroup = 'wx-company' | 'wx-role' | 'wx-bullet' | 'cert' | 'skill-cat'

const HOVER_BY_GROUP: Record<WorkExperienceDragGroup, string> = {
  'wx-company':
    'group-hover/wx-company:opacity-100 group-hover/wx-company:pointer-events-auto',
  'wx-role': 'group-hover/wx-role:opacity-100 group-hover/wx-role:pointer-events-auto',
  'wx-bullet': 'group-hover/wx-bullet:opacity-100 group-hover/wx-bullet:pointer-events-auto',
  cert: 'group-hover/cert:opacity-100 group-hover/cert:pointer-events-auto',
  'skill-cat':
    'group-hover/skill-cat:opacity-100 group-hover/skill-cat:pointer-events-auto',
}

/** Visible only while the pointer is over the matching named `group/{name}` ancestor. */
export default function WorkExperienceDragHandle({
  group,
  title = 'Перетащите для изменения порядка',
}: {
  group: WorkExperienceDragGroup
  title?: string
}) {
  return (
    <div
      className={`text-text-secondary transition-opacity pt-0.5 cursor-grab active:cursor-grabbing flex-shrink-0 opacity-0 pointer-events-none ${HOVER_BY_GROUP[group]}`}
      title={title}
      aria-hidden
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M4 8h16M4 16h16" />
      </svg>
    </div>
  )
}
